module.exports = "images/logo_white.png";